import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'components/ui/table';
import Text from 'components/Text';
import { ReactSVG } from 'react-svg';
import { delete_icon, edit_icon } from 'asset/icons';
import { fontSizes } from 'appconstants';
import CustomModal from './CustomModal';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';


interface Props {
    isStore?: boolean,
    array: Array<{ storeName?: string, roomName?: string, createdBy: number }>,
    setFieldValue: Function
}
const CustomTable = ({ isStore, array, setFieldValue }: Props) => {

    const { user } = useSelector((state: RootState) => state.common);

    const [showModal, setShowModal] = useState<boolean>(false)
    const [selectedData, setSelectedData] = useState<any>(null)
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null)

    const onAddRoomStore = (values: any, functions: any) => {
        const val = isStore ? "stores" : "rooms"
        const label = isStore ? "storeName" : "roomName"
        setFieldValue(val, [...array, { [label]: values?.name, createdBy: user?.userId }])
        functions.resetForm()
        setShowModal(false)
    }
    const onEditRoomStore = (values: any, functions: any) => {
        const val = isStore ? "stores" : "rooms"
        const label = isStore ? "storeName" : "roomName"
        let updated_array = [...array]
        updated_array[selectedIndex] = { ...updated_array[selectedIndex], [label]: values?.name }
        setFieldValue(val, updated_array)
        functions.resetForm()
        setShowModal(false)
        setSelectedData(null)
        setSelectedIndex(null)
    }

    const onEdit = (item: any, index: number) => {
        setSelectedIndex(index)
        setSelectedData(item)
        setShowModal(true)
    }

    const onDelete = (index: number) => {
        const val = isStore ? "stores" : "rooms"
        let arr = [...array]
        const updated_array = arr?.filter((val, ind) => index !== ind)
        setFieldValue(val, updated_array)
    }

    return (
        <div className='min-h-0'>
            <div className='mt-5 rounded-md border bg-white p-5 shadow-sm' >
                <div className='flex items-center justify-between '>
                    <Text text={isStore ? 'Stores' : 'Rooms'} className='font-bold' size={fontSizes.h20} />
                    <Text text={isStore ? 'Add Store +' : 'Add Room +'} size={fontSizes.h18} className='text-primary'
                        onClick={() => setShowModal(true)} />
                </div>
                <div className='rounded-xl border max-h-full overflow-y-auto mt-4'>
                    <Table>
                        <TableHeader>
                            <TableRow className='hover:bg-transparent'>
                                <TableHead className='px-4 text-black py-3 min-w-60'>{isStore ? 'Stores' : 'Rooms'}</TableHead>
                                <TableHead className='text-black min-w-40'>Action</TableHead>

                            </TableRow>
                        </TableHeader>

                        <TableBody>
                            {
                                array?.map((item, index) => (
                                    <TableRow className='hover:bg-muted/50'>
                                        <TableCell className='px-4 py-3'>
                                            <Text text={isStore ? item?.storeName : `Room ${item?.roomName}`} className='text-muted-foreground font-medium' />
                                        </TableCell>
                                        <TableCell>
                                            <div className='flex gap-4'>
                                                <div onClick={() => onEdit(item, index)}
                                                    className='flex items-center gap-1 cursor-pointer'>
                                                    <Text text='Edit' className='text-muted-foreground' />
                                                    <ReactSVG src={edit_icon} />
                                                </div>
                                                <div onClick={() => onDelete(index)}
                                                    className='flex items-center gap-1 cursor-pointer'>
                                                    <Text text='Delete' className='text-destructive' />
                                                    <ReactSVG src={delete_icon} />
                                                </div>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))
                            }

                        </TableBody>
                    </Table>
                </div>

            </div>

            <CustomModal
                open={showModal}
                isStore={isStore}
                onClose={() => setShowModal(false)}
                onAdd={selectedData ? onEditRoomStore : onAddRoomStore}
                selectedData={selectedData}
            />
        </div>
    );
};

export default CustomTable;
